module.exports = __webpack_public_path__ + "img/sebastian-savner-venner-3.24ded1f0.png";